"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AStyled = void 0;

var _utils = require("../../utils");

var _style = require("../../utils/style");

var _const = require("../../const");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AStyled = (0, _utils.styled)('a')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  ", ";\n  ", ";\n  color: ", ";\n  ", ";\n  ", ";\n  ", ";\n  cursor: pointer;\n  transition: 0.3s;\n  &:hover {\n    ", ";\n    ", ";\n  }\n  &:focus {\n    color: ", ";\n    outline: none;\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_ref) {
  var measure = _ref.measure;
  return _const.TextSize[measure];
}, function (props) {
  return props.lineHeight && (0, _const.lineHeightHelperStyle)(props.lineHeight);
}, function (_ref2) {
  var $letterSpacing = _ref2.$letterSpacing;
  return $letterSpacing && "letter-spacing: ".concat($letterSpacing, "px");
}, function (_ref3) {
  var $color = _ref3.$color;
  return _const.Colors[$color];
}, function (props) {
  return props.uppercase && (0, _style.uppercase)();
}, function (props) {
  return props.lineThrough && (0, _style.lineThrough)();
}, function (props) {
  return props.underline && (0, _style.underline)();
}, function (props) {
  return props.underline && 'text-decoration: none !important;';
}, function (props) {
  return props.hoverColor && "color: ".concat(_const.Colors[props.hoverColor], ";");
}, _const.Colors.focus, function (props) {
  return (0, _const.spacingStyle)(props);
}, function (_ref4) {
  var align = _ref4.align;
  return align && (0, _const.alignHelperStyle)(align);
}, function (_ref5) {
  var $textDecoration = _ref5.$textDecoration;
  return $textDecoration && (0, _const.textDecorationHelperStyle)($textDecoration);
}, function (_ref6) {
  var $fontWeight = _ref6.$fontWeight;
  return $fontWeight && (0, _const.fontWeightHelperStyle)($fontWeight);
}, function (_ref7) {
  var $fontFamily = _ref7.$fontFamily;
  return $fontFamily && (0, _const.fontFamilyHelperStyle)($fontFamily);
});
exports.AStyled = AStyled;